angular.module('app.supplyChain')

.controller('scorecardCtrl', function($location) {
	// redirect to new path
	var params = $location.search();
	var path = '/supply-chain/performance-summary/last-month-performance/';
	if (params['drilldown'] && params['drilldown'] === '1' && params['supplierNdx']) {
		params['view'] = 'scorecard';
		$location.path(path).search(params).replace();
	} else {
		$location.path(path).replace();
	}
});
